import { action, makeObservable, observable } from 'mobx';
import InvitationsStore from '../../Store';
import {
  State,
  confirmingDeactivate,
  deactivateSucceeded,
  deactivating,
  reactivateSucceeded,
  reactivating,
  waiting,
} from './Types';
import { InvitationResource } from '../Types';
import { assertNever } from '@kofno/piper';
import { TPlainTextKey } from '../../../../../../Translations';
import { error } from '../../../../../../ErrorHandling';

class InvitationStore {
  @observable
  state: State = waiting();

  readonly invitationsStore: InvitationsStore;

  constructor(invitationsStore: InvitationsStore) {
    makeObservable(this);
    this.invitationsStore = invitationsStore;
  }

  @action
  confirmingDeactivate = (resource: InvitationResource) => {
    switch (this.state.kind) {
      case 'waiting':
      case 'confirming-deactivate':
      case 'deactivate-succeeded':
      case 'reactivate-succeeded':
      case 'reactivating':
      case 'error':
        this.state = confirmingDeactivate(resource);
        break;
      case 'deactivating':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  deactivating = () => {
    switch (this.state.kind) {
      case 'confirming-deactivate':
        this.state = deactivating(this.state);
        break;
      case 'waiting':
      case 'error':
      case 'deactivating':
      case 'reactivating':
      case 'deactivate-succeeded':
      case 'reactivate-succeeded':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  reactivating = (resource: InvitationResource) => {
    switch (this.state.kind) {
      case 'waiting':
      case 'confirming-deactivate':
      case 'deactivate-succeeded':
      case 'reactivate-succeeded':
      case 'error':
        this.state = reactivating(resource);
        break;
      case 'deactivating':
      case 'reactivating':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  deactivateSucceeded = (resource: InvitationResource) => {
    switch (this.state.kind) {
      case 'deactivating':
        this.state = deactivateSucceeded(resource, this.state);
        break;
      case 'waiting':
      case 'confirming-deactivate':
      case 'error':
      case 'reactivating':
      case 'deactivate-succeeded':
      case 'reactivate-succeeded':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  reactivateSucceeded = (resource: InvitationResource) => {
    switch (this.state.kind) {
      case 'reactivating':
        this.state = reactivateSucceeded(resource, this.state);
        break;
      case 'waiting':
      case 'confirming-deactivate':
      case 'error':
      case 'deactivating':
      case 'deactivate-succeeded':
      case 'reactivate-succeeded':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  error = (msg: TPlainTextKey) => {
    this.state = error(msg);
  };
}

export default InvitationStore;
